/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Alarms_Form_Isenabled_True1Inputs */



/**
* | output |
* | --- |
* | "This alarm will be monitored and can trigger notifications" |
*
* @param {Alarms_Form_Isenabled_True1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const alarms_form_isenabled_true1 = /** @type {((inputs?: Alarms_Form_Isenabled_True1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Alarms_Form_Isenabled_True1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("This alarm will be monitored and can trigger notifications")
	return /** @type {LocalizedString} */ ("Cette alarme sera surveillée et les changements d'état seront enregistrés dans le journal")
});
export { alarms_form_isenabled_true1 as "alarms_form_isEnabled_true" }